/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-20 11:31:28
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-04-01 09:51:09
 * @FilePath: /qd-yunjing-web/src/router/modules/energy-conservation.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/layouts/index.vue';
import { TITLE_LIST } from '@/views/oss/alarm/constants';

export const energyConservationRoutes: RouteRecordRaw[] = [
  {
    path: '/energy-conservation',
    name: 'energy-conservation-root',
    component: Layout,
    meta: {
      authCodes: ['ENERGY_CONSERVATION'],
      icon: 'BarFull',
      title: '能源',
    },
    children: [
      {
        path: '/energy-conservation/index',
        name: 'energy-conservation-index',
        component: () => import('@/views/energy-conservation/index.vue'),
        meta: {
          authCodes: ['ENERGY_CONSERVATION'],
          title: '节能管理',
          isThreeModel: true,
          activeMenu: '/ems',
        },
      }
    ],
  }
];
